import { LogoutButton } from '@modules/Auth';
import { useTheme } from '@shared/components/ui/theme-provider';
import * as Icons from '@shared/components/ui/icons/warehouse.icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface LogoutMenuItemProps {
  className?: string;
  showIcon?: boolean;
}

export const LogoutMenuItem: React.FC<LogoutMenuItemProps> = ({ className = '', showIcon = true }) => {
  const { t } = useTranslation('menu');
  const { theme } = useTheme();

  // 🎯 Detectar si el tema actual es light
  const isLightTheme = React.useMemo(() => {
    if (theme === 'light') return true;
    if (theme === 'dark') return false;
    // Si es 'system', verificar la preferencia del sistema
    return !window.matchMedia('(prefers-color-scheme: dark)').matches;
  }, [theme]);

  // 🎯 Clase para iconos: !text-text en light, !text-icons en dark
  const iconColorClass = isLightTheme ? '!text-text' : '!text-icons';
  const iconColorStyle = isLightTheme ? {} : { color: 'var(--wrh-icons)' };

  return (
    <div className="flex items-center gap-2 w-full">
      {showIcon && (
        <span className={`${iconColorClass}`} style={iconColorStyle}>
          <Icons.CerrarIcon className={`!w-4 !h-4 ${iconColorClass}`} />
        </span>
      )}
      <LogoutButton
        variant="ghost"
        size="sm"
        className={`flex-1 justify-start px-0 py-1 h-auto !text-text ${className}`}
        showIcon={false}
        confirmLogout={true}
      >
        {t('logout')}
      </LogoutButton>
    </div>
  );
};

export default LogoutMenuItem;
